import Service from "./Service";

class ClaimApiService extends Service {
  constructor() {
    super("api");
  }

  async getTotalCostMax() {
    let result = await this.get(`Claims/GetTotalCostMax`, (status, data) => {
      return data;
    });
    return result;
  }

  async getAllowedFileExtension() {
    let result = await this.get(`Claims/GetAllowedFileExtension`, (status, data) => {
      return data;
    });
    return result;
  }

  async create(payload) {
    let result = await this.post(`Claims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async createContact(payload) {
    let result = await this.post(`Claims/Contact`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async createSurcharge(payload) {
    let result = await this.post(`Claims/Surcharge`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getAll(payload) {
    let result = await this.post(`Administration/GetClaims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async checkDuplicate(payload) {
    let result = await this.post(`Claims/CheckDuplicate`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getStatisticsInExcel(payload) {
    const url = `Administration/GetStatisticsInExcel`;
    const callBack = (status, data) => data;
    let result = await this.post(url, payload, callBack, "blob");
    return result;
  }

  async getMonthlyClaims(payload) {
    let result = await this.post(`Administration/GetMonthlyClaims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getMonthlyReimbursement(payload) {
    let result = await this.post(`Administration/GetMonthlyReimbursement`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getDailyClaims(payload) {
    let result = await this.post(`Administration/GetDailyClaims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getMostCommonTrainNumbers(payload) {
    let result = await this.post(`Administration/GetMostCommonTrainNumbers`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getMostCommonRoutes(payload) {
    let result = await this.post(`Administration/GetMostCommonRoutes`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getTotalReimbursementSEK(payload) {
    let result = await this.post(`Administration/GetTotalReimbursementSEK`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getCurrentApproveClaimJob() {
    let result = await this.get(`Administration/GetCurrentApproveClaimJob`, (status, data) => {
      return data;
    });
    return result;
  }

  async getApproveClaimJobById(id) {
    let result = await this.getWithoutTracker(`Administration/GetApproveClaimJobById?jobId=${id}`, (status, data) => {
      return data;
    });
    return result;
  }

  async approveClaims(payload) {
    let result = await this.post(`Administration/ApproveClaims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getClaimsForApprove(payload) {
    let result = await this.post(`Administration/getClaimsForApprove`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getApproveClaims(payload) {
    let result = await this.post(`Administration/GetApproveClaims`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getFraudReport(payload) {
    let result = await this.post(`Administration/GetFraudReport`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getFraud() {
    let result = await this.get(`Administration/GetFraud`, (status, data) => {
      return data;
    });
    return result;
  }

  async getClaimStatus() {
    let result = await this.get(`Administration/GetClaimStatus`, (status, data) => {
      return data;
    });
    return result;
  }

  async exportSUSFile(payload) {
    let result = await this.post(`Administration/ExportSusFile`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async createSwishPayout(payload) {
    let result = await this.post(`Administration/CreateSwishPayout`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getSwishPayouts(payload) {
    let result = await this.postWithoutTracker(`Administration/GetSwishPayouts`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async exportAccountingReport(payload) {
    let result = await this.post(`Administration/ExportAccountingReport`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async getTicketById(ticketId, ticketType) {
    let result = await this.get(`Claims/GetTicketById?ticketId=${ticketId}&ticketType=${ticketType}`, (status, data) => {
      return data;
    });
    return result;
  }
}

export default new ClaimApiService();
